import React from 'react';
import HomeHero from './HomeHero';
import HomeHeroTextColumns from './HomeHeroTextColumns';
import HomeHeroNewsletter from './HomeHeroNewsletter';
import FeaturedCollectionsCarousel from './FeaturedCollectionsCarousel';
import FeaturedBrandsCarousel from './FeaturedBrandsCarousel';
import FeaturedBrandLogosCarousel from './FeaturedBrandLogosCarousel';
import VideoModalPromo from './VideoModalPromo';
import TextCallout from './TextCallout';
import ProductDescription from './ProductDescription';
import ProductDetails from './ProductDetails';
import ProductVideoReviewPromo from './ProductVideoReviewPromo';
import FullBleedImage from './FullBleedImage';
import ProductMediaGallery from './ProductMediaGallery';
import BrandPromo from './BrandPromo';
import RelatedProductsPromo from './RelatedProductsPromo';
import ProductVideoReviewWithDescription from './ProductVideoReviewWithDescription';
import CtaCallout from './CtaCallout';
import NewReleaseEmailCaptureHero from './NewReleaseEmailCaptureHero';
import NewReleaseCountdown from './NewReleaseCountdown';
import ProductCatalogueGrid from './ProductCatalogueGrid';
import NewReleaseCarousel from './NewReleaseCarousel';
import Quote from './Quote';
import Gallery from './Gallery';
import BlogHero from './BlogHero';
import BlogBody from './BlogBody';
import FeaturedMedia from './FeaturedMedia';
import PostGrid from './PostGrid';
import VideoGrid from './VideoGrid';
import FeaturedReviews from './FeaturedReviews';

const ComponentList = ({
	components
}) => (
	<React.Fragment>{console.log({components})}{components.map(component => {
		switch (component._type) {
			case 'homeHero':
				return (
					<HomeHero
						key={component._key}
						{...component}
					/>
				);
			case 'homeHeroTextColumns':
				return (
					<HomeHeroTextColumns
						key={component._key}
						{...component}
					/>
				);
			case 'homeHeroNewsletter':
				return (
					<HomeHeroNewsletter
						key={component._key}
						{...component}
					/>
				);
			case 'featuredCollectionsCarousel':
				return (
					<FeaturedCollectionsCarousel
						key={component._key}
						{...component}
					/>
				);
			case 'featuredBrandsCarousel':
				return (
					<FeaturedBrandsCarousel
						key={component._key}
						{...component}
					/>
				);
			case 'featuredBrandLogosCarousel':
				return (
					<FeaturedBrandLogosCarousel
						key={component._key}
						{...component}
					/>
				);
			case 'videoModalPromo':
				return (
					<VideoModalPromo
						key={component._key}
						{...component}
					/>
				);
			case 'productDescription':
				return (
					<ProductDescription
						key={component._key}
						{...component}
					/>
				);
			case 'productReviewPromo':
				return (
					<ProductVideoReviewPromo
						key={component._key}
						{...component}
					/>
				);
			case 'productReviewWithDescription':
				return (
					<ProductVideoReviewWithDescription
						key={component._key}
						{...component}
					/>
				);
			case 'productDetails':
				return (
					<ProductDetails
						key={component._key}
						{...component}
					/>
				);
			case 'fullBleedImage':
				return (
					<FullBleedImage
						key={component._key}
						{...component}
					/>
				);
			case 'mediaGallery':
				return (
					<ProductMediaGallery
						key={component._key}
						{...component}
					/>
				);
			case 'brandPromo':
				return (
					<BrandPromo
						key={component._key}
						{...component}
					/>
				);
			case 'relatedProductsPromo':
				return (
					<RelatedProductsPromo
						key={component._key}
						{...component}
					/>
				);
			case 'textCallout':
				return (
					<TextCallout
						key={component._key}
						{...component}
					/>
				);
			case 'ctaCallout':
				return (
					<CtaCallout
						key={component._key}
						{...component}
					/>
				);
			case 'newReleaseEmailCaptureHero':
				return (
					<NewReleaseEmailCaptureHero
						key={component._key}
						{...component}
					/>
				);
			case 'newReleaseCountdown':
				return (
					<NewReleaseCountdown
						key={component._key}
						{...component}
					/>
				);
			case 'productCatalogueGrid':
				return (
					<ProductCatalogueGrid
						key={component._key}
						{...component}
					/>
				);
			case 'newReleaseCarousel':
				return (
					<NewReleaseCarousel
						key={component._key}
						{...component}
					/>
				);
			case 'gallery':
				return (
					<Gallery
						key={component._key}
						{...component}
					/>
				);
			case 'blogHero':
				return (
					<BlogHero
						key={component._key}
						{...component}
					/>
				);
			case 'featuredMedia':
				return (
					<FeaturedMedia
						key={component._key}
						{...component}
					/>
				);
			case 'postGrid':
				return (
					<PostGrid
						key={component._key}
						{...component}
					/>
				);
			case 'videoPostGrid':
				return (
					<VideoGrid
						key={component._key}
						{...component}
					/>
				);
			case 'blogBody':
				return (
					<BlogBody
						key={component._key}
						{...component}
					/>
				);
			case 'quote':
				return (
					<Quote
						key={component._key}
						{...component}
					/>
				);
			case 'featuredReviews':
				return (
					<FeaturedReviews
						key={component._key}
						{...component}
					/>
				);
		}
	})}</React.Fragment>
);

ComponentList.defaultProps = {
	components: [],
};

export default ComponentList;